import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TuiIcon } from '@taiga-ui/core';
import { TuiAvatar, TuiBadgedContent, TuiBadgeNotification } from '@taiga-ui/kit';
import { TranslocoDirective } from '@jsverse/transloco';

import { TicketsService } from '../../../services/tickets.service';
import { Router } from '@angular/router';
import { ROUTES_CONST } from '../../../const/menu';

@Component({
  selector: 'app-practice',
  standalone: true,
  imports: [
    CommonModule,
    TuiAvatar,
    TuiBadgedContent,
    TuiBadgeNotification,
    TuiIcon,
    TranslocoDirective,
  ],
  templateUrl: './practice.component.html',
  styleUrls: ['./practice.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PracticeComponent {
  public readonly router = inject(Router);
  ROUTES_CONST = ROUTES_CONST;

  objTickets;

  constructor(
    private ticketsService: TicketsService
  ) {
  }
  ngOnInit() {
    this.objTickets = this.ticketsService.buildTicketsList();
    console.log('objTickets', this.objTickets);
  }
}
